var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoppelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 55,
    viewBox: "0 0 73 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62888 0H69.4219C70.8824 0 72.0508 1.33353 72.0508 2.95979V52.0077C72.0508 53.6339 70.85 54.9675 69.4219 54.9675H2.62888C1.16839 54.9675 0 53.6339 0 52.0077V2.99231C0 1.36606 1.16839 0 2.62888 0Z",
    fill: "#005FAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.967 35.3223H62.3466V43.6487H59.1985V40.5588H56.1152V43.6487H52.967V35.3223Z",
    fill: "#FFE400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2352 34.8669H51.3443H27.2301C27.5871 35.6801 27.7818 36.5582 27.7818 37.5015C27.7818 40.9491 24.9906 43.7788 21.5504 43.7788C18.1101 43.7788 15.5137 41.1443 15.319 37.8593C14.6049 38.152 13.826 38.3146 13.0146 38.3146C9.57436 38.3146 6.7832 35.4849 6.7832 32.0373C6.7832 28.5896 9.57436 25.7599 13.0146 25.7599C13.826 25.7599 14.6049 25.9225 15.319 26.2153C15.4812 22.9302 18.2399 20.2632 21.5504 20.2632C24.8608 20.2632 27.7818 23.0928 27.7818 26.5405C27.7818 27.4837 27.5546 28.427 27.1651 29.2401H65.2352V34.8669ZM21.5504 23.5482C23.0758 23.5482 24.3415 24.8167 24.3415 26.3454C24.3415 27.874 23.1082 29.1425 21.5504 29.1425C19.9925 29.1425 18.7592 27.874 18.7592 26.3454C18.7592 24.8167 20.025 23.5482 21.5504 23.5482ZM13.3392 29.2401C14.8646 29.2401 16.1303 30.5086 16.1303 32.0373C16.1303 33.5659 14.8646 34.8344 13.3392 34.8344C11.8138 34.8344 10.548 33.5659 10.548 32.0373C10.548 30.5086 11.8138 29.2401 13.3392 29.2401ZM21.5504 34.8344C23.0758 34.8344 24.3415 36.1029 24.3415 37.6641C24.3415 39.2253 23.1082 40.4613 21.5504 40.4613C19.9925 40.4613 18.7592 39.1928 18.7592 37.6641C18.7592 36.1354 20.025 34.8344 21.5504 34.8344Z",
    fill: "#FFE400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoppelIcon);
export default __webpack_public_path__ + "static/media/coppelIcon.153e08d617ab64bcd898f7869ac59932.svg";
export { ForwardRef as ReactComponent };